import type { DomainConfiguration } from '@/router/types/DomainConfiguration'
import type { SSRContext } from '@/types/ssr/SSRContext'
import { getConfigurationFromUrl } from '@/config/domains/utils/getConfigurationFromUrl'

export const getActiveConfiguration = (ssrContext?: SSRContext): DomainConfiguration => {
  return getConfigurationFromUrl(ssrContext ? ssrContext.url : window.location.href)
}

